import fetchApi from "../fetchApi";
export const DeleteProgramReport = async (report) => {
  const options = {
    method: "DELETE",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    redirect: "follow",
  };

  return await fetchApi(
    `card-issuing/company/program-report/${report.program_id}/subscription/${report.id}`,
    options
  );
};
